<template>
  <div class="content">
    <Header :title="'消费币明细'" />
    <div class="tab-wrap">
      <div class="tab-body">
        <!-- 兑 换 -->
        <div class="tab">
          <div class="search-wrap">
            <div class="txt-wrap">
              <div class="txt-search" @click="getDate()">{{ dateRegion }}</div>
              <div class="btn-wrap">
                <input class="btn-search" type="button" value="搜索" @click="onSearch">
              </div>
            </div>
          </div>

          <div class="lists">
            <ul>
              <li class="title">
                <span>消费币</span>
                <!-- <span>类型</span> -->
                <span>操作时间</span>
                <span>操作人</span>
                <span>状态</span>
              </li>
              <li v-for="(item,index) in list" :key="index">
                <span>{{ item.currency || '0' }}</span>
                <!-- <span>{{item.formDescription || '暂无描述'}}</span> -->
                <span>{{ item.createdDate || '暂无' }}</span>
                <span>{{ item.member || '暂无' }}</span>
                <span>{{ item.isInDescription || '暂无' }}</span>
              </li>
              <div v-show="list.length===0" class="no-data">抱歉！暂无数据</div>
            </ul>
          </div>

          <!-- 分页 -->
          <div class="page-container">
            <van-pagination
              v-model="pageIndex"
              :items-per-page="pageSize"
              :show-page-size="3"
              :total-items="total"
              force-ellipses
              @change="pageChange"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 日历 -->
    <nut-calendar
      :animation="`nutSlideUp`"
      :default-value="date"
      :end-date="null"
      :is-visible.sync="isVisible"
      :start-date="null"
      type="range"
      @choose="setChooseValue"
      @close="switchPickerClose('isVisible')"
    />
    <!-- 底部 -->
    <Footer :active="4" />
  </div>
</template>
<script>
import Vue from 'vue'
import { Pagination } from 'vant'
import { currencyDetail } from '@/api/Personal/Setting'
import Header from '@/components/Header/Index'
import Footer from '@/components/Footer/Index'

Vue.use(Pagination)

export default {
  name: 'MoneyDetail',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      dateRegion: '选择时间区间',
      sd: '', // 2019-01-05
      ed: '', // 2020-03-18
      st: 'all',
      date: null,
      pageIndex: 1,
      pageSize: 8,
      total: 0,
      tabIndexShow: 0,
      isVisible: false,
      list: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getClass(item, index) {
      this.cardIndex = index
      this.cardMoney = item
    },
    pageChange() {
      this.getList()
    },
    onSearch() {
      this.getList()
    },
    getList() {
      const _this = this

      const params = {
        sd: this.sd,
        ed: this.ed,
        st: this.st,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      currencyDetail(params).then(res => {
        this.total = res.data.total
        if (res.data.rows) {
          this.list = res.data.rows
          this.list.forEach(item => {
            item.createdDate = _this.$formatDate(item.createdDate.slice(0, 10), '.')
          })
        }
      })
    },
    switchPickerClose(param) {
      // console.log('close:' + param)
    },
    setChooseValue(param) {
      this.date = [...[param[0][3], param[1][3]]]
      this.dateRegion = param[0][3] + '至' + param[1][3]
      this.sd = param[0][3]
      this.ed = param[1][3]
    },
    getDate() {
      this.isVisible = true
    }
  }
}
</script>
<style lang='scss' scoped>
// 分页
.van-pagination {
  margin-bottom: 30px;
  justify-content: center;

  ::v-deep .van-pagination__item {
    color: #555;
    border-radius: 5px;
    margin: 0 3px;
    font-weight: bold;
    height: 35px;
  }

  ::v-deep .van-pagination__item::after {
    display: none;
  }

  ::v-deep .van-pagination__item:disabled {
    background: #fff;
    opacity: 1;
    color: #ddd;
  }

  ::v-deep .van-pagination__item:active {
    background-color: $primary-color-bright;
    color: #fff;
  }

  ::v-deep .van-pagination__item--disabled {
    background: #fff;
    opacity: 1;
    color: #ddd;
  }

  ::v-deep .van-pagination__item--active {
    background-color: #fff;
    color: $primary-color;
  }

  ::v-deep .van-pagination__prev {
    max-width: 150px;
  }

  ::v-deep .van-pagination__next {
    max-width: 150px;
  }
}

//日历
::v-deep .nut-calendar-months .nut-calendar-month-con .nut-calendar-month-day-active {
  background-color: #eea105;
}

::v-deep .nut-calendar-months .nut-calendar-month-con .nut-calendar-month-day-choose {
  background-color: #dad1c0;
}

::v-deep .nut-calendar-control .nut-calendar-cancel-btn,
.nut-calendar-control .nut-calendar-confirm-btn {
  color: #eda104;
  font-weight: 600;
}

::v-deep .nut-calendar-control .nut-calendar-week span:first-child,
.nut-calendar-control .nut-calendar-week span:last-child {
  color: #eda104;
}

.content {
  width: 100vw;
  min-height: 0;
  height: auto;
  overflow: hidden;
  padding: 18px 0 80px 0;

  .tab-head {
    width: 100%;
    height: 40px;
    line-height: 40px;
    position: relative;
    box-sizing: border-box;
    overflow: hidden;

    .col-2 {
      width: 50%;
      height: 40px;
      float: left;
      position: relative;
      text-align: center;
      box-sizing: border-box;
      color: #4d4d4d;
      border-bottom: 2px solid #cccccc;
      font-size: 16px;
      font-weight: 600;

      &.active {
        color: #eea105;
        border-bottom: 2px solid #eea105;
      }
    }
  }

  .tab-body {
    width: 100%;
    min-height: 0;
    height: auto;
    overflow: hidden;
    padding: 18px;
    box-sizing: border-box;

    .tab {
      width: 100%;
      min-height: 0;
      height: auto;
      overflow: hidden;
      position: relative;

      .search-wrap {
        width: 100%;
        height: 60px;

        .txt-wrap {
          width: 100%;
          position: relative;
          box-sizing: border-box;
          padding-right: 90px;

          .txt-search {
            width: 100%;
            height: 40px;
            line-height: 40px;
            background: #ffffff;
            border: none;
            color: #4c4c4c;
            outline: none;
            border-radius: 5px;
            font-size: 14px;
            box-sizing: border-box;
            padding: 0 10px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .btn-wrap {
            width: 80px;
            height: 40px;
            position: absolute;
            right: 0;
            top: 0;

            input {
              width: 100%;
              height: 40px;
              background: #eea105;
              border: none;
              color: #ffffff;
              outline: none;
              border-radius: 5px;
              -webkit-appearance: none;
              appearance: none;
              font-size: 14px;
              text-align: center;
            }
          }
        }
      }

      .lists {
        width: 100%;
        min-height: 50px;
        height: auto;
        overflow: hidden;
        background: #ffffff;
        border-radius: 5px;
        margin-bottom: 20px;
        box-sizing: border-box;
        padding: 0 0 10px 0;

        ul {
          display: block;
          width: 100%;
          height: 100%;

          li {
            span {
              display: block;
              float: left;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 12px;
              color: #bcbcbc;
              text-align: center;
              line-height: 40px;
              height: 40px;
              padding: 0 5px;
              box-sizing: border-box;
            }

            span:nth-of-type(1) {
              width: 20%;
            }

            span:nth-of-type(2) {
              width: 30%;
            }

            span:nth-of-type(3) {
              width: 25%;
            }

            span:nth-of-type(4) {
              width: 25%;
            }

            .btn-query {
              padding: 0px 20px;
            }
          }

          .title {
            width: 100%;
            height: 50px;
            border-bottom: 1px solid #f7f7f7;

            span {
              font-weight: 600;
              color: #4d4d4d;
              line-height: 50px;
            }
          }

          .no-data {
            width: 100%;
            height: 40px;
            line-height: 40px;
            font-size: 12px;
            color: #999999;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
